module.exports = __webpack_public_path__ + "static/img/data2.bd5700b7.png";